// extracted by mini-css-extract-plugin
module.exports = {"title":"home_title__13xbD","preview":"home_preview__1kdzB"};